import React, { useState } from 'react';
// import { BlurView } from "@react-native-community/blur";
import {
  View,
  TouchableOpacity,
  StyleSheet,
  FlatList,
  ImageURISource,
  Image,
  Text
} from 'react-native';
// import CheckBox from 'expo-checkbox';
import ModalComponent from '../../ModalComponent';
import GlobalStyles from '../../../globalStyles/globalStyles';
import { Colors } from '../../../globalStyles/ColorConfig';
import CustomComponent from '../../../components/CustomComponent';
import Icons from '../../../assets/Icons/ExperienceIcons';
import dimensions from '../../../globalStyles/dimensions';




const CircleDesign = () => {
  return (
    
    <View style={[styles.optionCircle, styles.optionOnSelect]}>
    <View style={styles.optionCircleInner}>

    </View>
  </View>
    
  );
};


interface SelectCountryProps {
  isDialog?: boolean;
  isVisible: boolean;
  toggleModal: () => void;
  method1: any;
  method3:any;
}

export default function ReportModal({
  isDialog = false,
  isVisible,
  toggleModal,
  method1,
  method3,
}: SelectCountryProps) {
  const [toggleCheckBox, setToggleCheckBox] = useState(false);
  
  const [reason, setReason] = useState('')


  return (
    <ModalComponent
      
      isVisible={isVisible}
      toggleModal={toggleModal}
    >
      <View style={{height:'100%',backgroundColor:'rgba(0,0,0,0.4)'}}>
      <View style={styles.countryContainer}>
        <View style={styles.countryHeader}>
          <CustomComponent.TextView
            title='Report profile?'
            textStyle={GlobalStyles.heading2}
          />
          <TouchableOpacity onPress={toggleModal} >
            <Icons.Cross />
          </TouchableOpacity>
        </View>
        <View style={{
        flex: 1,
        paddingHorizontal: 25,
        // paddingTop: 30,
      }}>
       
        <View >
          <View style={styles.optionBox}>
          <TouchableOpacity onPress={()=>{setReason('Inappropriate Behavior');method3(reason)}}>
          <View style={styles.optionBoxInnerBox}>
              <Text style={styles.optionText}>Inappropriate Behavior</Text>
              { reason=='Inappropriate Behavior' ? <CircleDesign /> : <View style={styles.optionCircle}></View>}
              
            </View>
          </TouchableOpacity>

          <TouchableOpacity onPress={()=>{setReason('Scamming or Catfishing');method3(reason)}}>
          <View style={styles.optionBoxInnerBox}>
              <Text style={styles.optionText}>Scamming or Catfishing</Text>
              { reason=='Scamming or Catfishing' ? <CircleDesign /> : <View style={styles.optionCircle}></View>}
            </View>

          </TouchableOpacity>

          <TouchableOpacity onPress={()=>{setReason('Disrespectful or Offensive Language');method3(reason)}}>
          <View style={styles.optionBoxInnerBox}>
              <Text style={styles.optionText}>Disrespectful or Offensive Language</Text>
              { reason=='Disrespectful or Offensive Language' ? <CircleDesign /> : <View style={styles.optionCircle}></View>}
            </View>

          </TouchableOpacity>
          <TouchableOpacity onPress={()=>{setReason('Prefer not to say');method3(reason)}}>
          <View style={styles.optionBoxInnerBox}>
              <Text style={styles.optionText}>Prefer not to say</Text>
              { reason=='Prefer not to say' ? <CircleDesign /> : <View style={styles.optionCircle}></View>}
            </View>

          </TouchableOpacity> 
          </View>
          
        </View>

        <TouchableOpacity style={styles.buttonStyle} onPress={method1}>
             <Text style={{color:'white'}}>Continue</Text>
        </TouchableOpacity>
        
      </View>
        
      </View>
      </View>

      
    </ModalComponent>
  );
}
const styles = StyleSheet.create({
  countryContainer: {
    
    height: '55%',
    width: '100%',
    backgroundColor: Colors.white10,
    
    position:'absolute',
    bottom:0
  },
  countryHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: dimensions.paddingVertical,
    paddingHorizontal: dimensions.paddingHorizontal,
  },
  selectGender: [
    GlobalStyles.heading3, GlobalStyles.black90,
    
],
optionBox: {
    marginTop: 10,
},
optionBoxInnerBox: {
    height: 50,
    borderBottomColor: "#cac9c7",
    borderBottomWidth: 1,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center"
},
checkBox: {
    // backgroundColor:"rgba(192, 164, 111, 1)",

},
optionText: 
    {
        color: "black",
        fontSize:16,
        fontWeight:'400'
    }
,
middleScreen: {
  height: "70%"
},
tophead: {
  height: 100,
  display: "flex",
  flexDirection: 'row',
  alignItems: "center",
  // backgroundColor:"green",

  // justifyContent:'center'
  columnGap: 12
},
optionCircle: {
    borderWidth: 1,
    height: 30,
    width: 30,
    borderRadius: 16,
    borderColor: "#cac9c7"
},
optionCircleInner: {
    height: 10,
    width: 10,
    borderRadius: 7,
    backgroundColor: "white",
    zIndex: 12
},
optionOnSelect: {
    backgroundColor: "rgba(192, 164, 111, 1)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
},
circleView: { height: 45, width: 45, borderRadius: 25, borderColor: "black", borderWidth: 1, display: "flex", justifyContent: "center", alignItems: "center" },
    circleViewSmall: { height: 8, width: 8, borderRadius: 7, backgroundColor: '#cac9c7' },
    

    buttonStyle:{
      backgroundColor:'rgba(31, 57, 48, 1)',
      marginTop:50,
      height:50,
      borderRadius:40,
      display:'flex',
      justifyContent:'center',
      alignItems:'center'
    }


});
